import mqtt from "mqtt/dist/mqtt";
import axios from "axios";
import React, { useState, useEffect, useRef } from 'react';
import download from 'downloadjs';
import {Button} from 'react-bootstrap';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import axiosIstance from "../utils/axiosIstance";
import PopupReqCntrl from "./PopupReqCntrl";
import { Modal, ModalBody } from 'react-bootstrap';
import secureSessionStorage from 'react-secure-storage'
    





// const client = mqtt.connect(host, mqttOptions);

function ClientMQTT({updateCntrl, portWasOpen}) {


    const [ConnectStatus, setConnectStatus] = useState(null);
    const [Payload, setPayload] = useState([]);
    const [client, setClient] = useState(null);
    const [file, setFile] = useState();
    const [errorUpload, setErrorUpload] = useState(false);
    const [errorX11, setErrorX11] = useState(false);
    const fileInputRef = useRef();
    const [ShowDisconnected, setShowDisconnected] = useState(false);
    const [NumberRef, setNumberRef] = useState(0);
    const [TimeOut, setTimeOut] = useState(1 * 60 * 1000);
    const [ShowPopUpTimer, setShowPopUpTimer] = useState(false);
    const [SessionRefForPopUp, setSetSessionRefForPopUp] = useState();
  
    const host = "ws://95.110.236.199:8083/mqtt";
    // const host = "95.110.236.199";
    const port = "8083";
    const clientId = "remote_webp";
    // const timeout = 1 * 60 * 1000;
    //const connectUrl = `mqtt://${host}:${port}`;

    const id = secureSessionStorage.getItem('sessionRef')

    const mqttOptions =  {
        clientId: id,
        clean: true,
        username: "remote_webp",
        password: "remote_webp",
        reconnectPeriod: 0,       //DA LASCIARE A ZERO SE NO MQTT SCLERA 
    };

    const mqttConnect = () => {
      setConnectStatus('Connecting');
      setClient(mqtt.connect(host, mqttOptions));
    };

    const handleReqCntrlReply = (res, sessionRef) => {

      setShowPopUpTimer(false);

      if(res){
        console.log('set isC a 0');
        secureSessionStorage.setItem('isC', 0);
        updateCntrl();
      }

      const username =  (secureSessionStorage.getItem('username'));
      try {
        axios.post("http://95.110.236.199:3001/reqcntrlres", {res: res, username: username, sessionRef: sessionRef})
        .then( res => console.log(res) );
      } catch (error) {
        console.log(error);
      }

    }

    const handleFileChange = (e) => {
      console.log('handleFileChanges')
      
      setFile(e.target.files[0]);
      
    }
  
    //setClient(mqtt.connect(host, mqttOptions));
    const removeFileFromASRV = async (filename) => {
      try {
        let res  = await axios.post("http://95.110.236.199:3001/removeupload", {filename: filename}).then(
          fileInputRef.current.value = null
        )
      } catch (error) {
        console.log(error);
      }
    } 

    const handleUploadFile = async (e) => {
      
      if (!file) {
        return;
      }
      console.log('handleUploadFile');
      const username =  (secureSessionStorage.getItem('username'));
      const formData = new FormData();
      formData.append("file", file);
      formData.append('username', username);

      try {
        axios.post("http://95.110.236.199:3001/upload", formData
          , { headers: {
            'Content-Type': 'multipart/form-data'
          }
        })  
      } catch (error) {
        setErrorUpload(true);
        console.log(error);
      }
    }
        
    const downloadFile = async (e) => {
        const username = (secureSessionStorage.getItem('username'));
        try {
          axios.post("http://95.110.236.199:3001/download", {username: username}, {responseType: 'blob' } )
          .then( res => download(res.data, 'test.zip') );
        } catch (error) {
          console.log(error);
        }
    }

    const  parse = (p) => {
        let parsed = JSON.parse(p.message);
        console.log(parsed);
        switch (parseInt(parsed.f)) {
            case 1:{
                submitConfirmDownload();
                // downloadFile();
            }break;
            case 2:{
              setErrorUpload(false);
              submitConfirmUpload(parsed.filename);
              removeFileFromASRV(parsed.filename);
            }break;
            case 5:{
              setDeivceConnected();
            }break;
            case 6:{
              //num ref;
              setNumberRef(parsed.ref);
            }break;
            case 7:{
              let  sessionRef = secureSessionStorage.getItem('sessionRef');

              let s1 = new String(sessionRef);
              let s2 = new String(parsed.sessionRef);

              console.log("sessionRef =>", s1);
              console.log("parsed.sessionRef =>",s2);
              
              if(parsed.sessionRef !== sessionRef){
                //messagio per me
                console.log("messagio per me ...")
                //solo se sono il controllo devo acconsetire al controllo
                //if(secureSessionStorage.getItem('isC') == 1){
                  showReqCntrl(parsed.sessionRef);
                //}
              }else{
                console.log("messaggio INVIATO DA ME ") 
              }
            }break;
            case 8:{
              let  sessionRef = secureSessionStorage.getItem('sessionRef');
            
              let s1 = new String(sessionRef);
              let s2 = new String(parsed.sessionRef);

                console.log("sessionRef =>", s1);
                console.log("parsed.sessionRef =>",s2);

                console.log("s1.localeCompare(s2)",s1.localeCompare(s2));
                
              if(s1.localeCompare(s2) == 0){
                  //messagio per me
                  console.log("update isC");
                  
                  console.log('set isC a '  + parsed.res);
                  secureSessionStorage.setItem('isC', parsed.res);

                 updateCntrl();
              }
            }break;
            case 9:{
              portWasOpen();
            }break;
            case 10:{
              return(
                <div>
                  Remote Control Is Not Enable On Device
                </div>
              )
            }
            case 99:{
              showX11NotRunning();
            }break;
        }
    }

    const setDeivceDisconnected = () => {
      setShowDisconnected(false);
    }

    const setDeivceConnected = () => {
      setShowDisconnected(true);
    }
 
    const showReqCntrl = (sessionRef) => {

      setShowPopUpTimer(true);
      setSetSessionRefForPopUp(sessionRef);
      
      // console.log('showReqCntrl')
      // return (<Modal show={true}>
      // <ModalBody>
      // {`Request Cntrl, Timeout: ${parseInt(TimeOut) / 1000} seconds`}
      // </ModalBody>
      // </Modal>)
    
      
      // const interval = setInterval(()=>{
      //   console.log('setInterval');
      //   if(TimeOut > 0){
      //     console.log('setInterval 2');
      //     setTimeOut(TimeOut - 1000);
      //   }
      // },1000);

      // confirmAlert({
      //   title: 'Reqest Cntrl',
      //   message: `Request Cntrl, Timeout: ${parseInt(TimeOut) / 1000} seconds`,
      //   buttons: [
      //     {
      //       label: 'OK',
      //       onClick: () => handleReqCntrlReply(true, sessionRef)
      //     }
      //   ]
      // })

      
    };

    const showX11NotRunning = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
      return (
        <div className='custom-ui'>
          <h1>Are you sure?</h1>
          <p>You want to delete this file?</p>
          <button onClick={onClose}>No</button>
          <button
            onClick={() => {
              this.handleClickDelete();
              onClose();
            }}
          >
            Yes, Delete it!
          </button>
        </div>
      );
    }
    });
    };

    const submitConfirmDownload = () => {
        confirmAlert({
          title: 'Confirm to download',
          message: 'Download File From Device ?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => downloadFile() 
            },
            {
              label: 'No'
            }
        ]
      });
    };

    const submitConfirmUpload = (f) => {
      errorUpload ? 
      confirmAlert({
          title: 'Upload Status',
          message: `File ${f} Uploaded Failed`,
          buttons: [
            {
              label: 'OK',
            }
          ]
        })
    :
    confirmAlert({
        title: 'Upload Status',
        message: `File ${f} Uploaded successfully`,
        buttons: [
          {
            label: 'OK',
          }
      ]
      });
    };

    const disconnectedDeviceConfirmAlert = () => {
        console.log('disconnectedDeviceConfirmAlert');

        console.log('ShowDisconnected', ShowDisconnected);
        
        ShowDisconnected ? <></>
        :
        confirmAlert({
          title: 'Device Disconnected',
          message: 'Device Disconnected',
          buttons: [
            {
              label: 'OK',
              onClick: () => {}
            }
          ]
        });
    } 
    
   
    const mqttSub = (subscription) => {
      console.log('-  -mqttSub-  -  ');
      if (client) {
        const dus =   secureSessionStorage.getItem('username');
        const topicData = "remote-device/from_device/" + dus +"/#";
        client.subscribe([topicData], (err) => {
            if(err) console.log(err +  `on Subscribe to topic ${topicData}`)
            console.log(`Subscribed to topic ${topicData}`)
        });
      }else{
        console.log('-  - null client -  -  ');
      }
    };

   
    useEffect(() => {
      console.log('useEffect client mqtt');
      console.log("ConnectStatus =>", ConnectStatus)
      if (client) {
        console.log("client =>", client)
        client.on('connect', () => {
            console.log('=>', ConnectStatus);
             setConnectStatus('Connected');
             mqttSub();
          });

          client.on('disconnect', () => {
            console.log('DisconnectStatus');
            setConnectStatus('Disconnected');
           
             
            });
    
        client.on('close', (err) => {
          console.error('Close error: ', err);
          setConnectStatus('Close');
          mqttConnect();
          
        });
        client.on('error', (err) => {
          console.error('Connection error: ', err);
          setConnectStatus('Error');
          
        });
        client.on('reconnect', () => {
          setConnectStatus('Reconnecting');
        });
        client.on('message', (topic, message) => {
          const payload = { topic, message: message.toString() };
          parse(payload);
        });
      }else if (ConnectStatus !== 'Connected' ){
          console.log('try connecting')
          setConnectStatus('try connecting');
          mqttConnect();
      }

    return () => {
      // if(client){
      //   console.log('Umounted successfu{lly');
      //   setClient(null);
      //   setConnectStatus(null);
      // }
    };
      
    

        
    }, [client]);

    const handleReqCntrl  = () => {
      console.log('client request', client);
      const username   = (secureSessionStorage.getItem('username'));
      const sessionRef = (secureSessionStorage.getItem('sessionRef'));
      
      try {
        axios.post("http://95.110.236.199:3001/reqcntrl", {username: username, sessionRef: sessionRef, timeout:TimeOut})
        .then( res => console.log(res) );
      } catch (error) {
        console.log(error);
      }
    }

    const handleClose = () => {
      setShowPopUpTimer(false)
    }

    return ( <>
      <div style={{display:'flex', justifyContent:'row', gap:'10px', alignItems:'center'}}>
        <div>{NumberRef}</div> 
        <input type="file" onChange={handleFileChange} ref={fileInputRef} />
        <Button onClick={handleUploadFile}>Update</Button>
        <Button disabled={secureSessionStorage.getItem('isC') == 1 ? true : false} onClick={handleReqCntrl}>Request Control</Button>
        {/* <Button onClick={handleReqCntrl}>Request Control</Button> */}
      </div>
      {
        ShowPopUpTimer && 
        <PopupReqCntrl TimeOut={TimeOut} 
          SessionRefForPopUp={SessionRefForPopUp} 
          handleReqCntrlReply={handleReqCntrlReply} 
          handleClose={handleClose}>
        </PopupReqCntrl>
      }

    </> );
}

export default ClientMQTT;